<template>
    <div class="custom-tweet-display" v-if="tweet">
        <div class="custom-tweet-display-header">
            <div class="custom-tweet-display-name">{{tweet.user.name}}</div>
            <div class="custom-tweet-display-screenname">&#64;{{tweet.user.screen_name}}</div>
        </div>

        <p>{{tweet.full_text}}</p>
    </div>
</template>

<script>
    export default {
        name: "CustomTweetDisplay",
        props: {
            tweet: {
                type: Object,
                default: null
            }
        }
    }
</script>

<style scoped>

</style>
